/**
 * `@ecom/ui-kit`'s `MoneyText`/`@ecom/i18n`'s `formatMoney` both expect an
 * INTEGER MILLIME count (DEV §6.15's orders/checkout convention — "smallest
 * unit", exactly what `formatMillimesAsTnd` divides by 1000).
 *
 * `products.price` (and `compare_at_price`, `purchase_price`) is a
 * DIFFERENT, EARLIER convention: `numeric(12,3)` storing a TND amount
 * DIRECTLY, with millime precision as its three decimal places — verified
 * against the real database, not assumed: `SELECT price FROM products`
 * returns `"56.222"` (56 dinars, 222 millimes), never `"56222.000"`.
 * Passing that value straight into `MoneyText`'s `amountMillimes` would
 * divide it by 1000 a SECOND time and render roughly a thousandth of the
 * real price — a genuine display bug this file exists to avoid, not a
 * hypothetical one.
 *
 * This formatter matches `formatMillimesAsTnd`'s visible conventions
 * exactly (fr-TN locale, TND currency, three fraction digits — PDF §27's
 * "affichage avec le nombre de décimales usuel (millimes)") without
 * dividing by 1000, because the input here already IS the TND amount.
 */
export function formatCatalogPrice(amountTnd: number): string {
  if (!Number.isFinite(amountTnd)) {
    throw new RangeError(`formatCatalogPrice received a non-finite amount: ${String(amountTnd)}`);
  }

  return new Intl.NumberFormat('fr-TN', {
    style: 'currency',
    currency: 'TND',
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(amountTnd);
}
